import { CategoryCreatedEvent } from '@rematter/frontend-lib-api-client/grpc/inventory/v1/category_events_pb';
import { Col, FieldDisplay, IDField } from '@rematter/ui-web';

type CategoryCreatedDetailProps = {
  event: CategoryCreatedEvent;
};

export const CategoryCreatedDetail = ({
  event,
}: CategoryCreatedDetailProps) => {
  const category = event.category;

  if (!category) {
    return (
      <Col className="@CategoryCreatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const attributes = category.attributes as Record<string, unknown> | undefined;
  const hasAttributes = attributes && Object.keys(attributes).length > 0;

  return (
    <Col className="@CategoryCreatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Category Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={category.id?.value} />
          <FieldDisplay label="Name" value={category.name} />
          <FieldDisplay label="Description" value={category.description} />
          <IDField
            label="Organization ID"
            value={category.base?.organizationId?.value}
          />
        </div>
      </Col>
      {hasAttributes && (
        <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
          <span className="text-xs font-medium text-neutral/60">
            Attributes
          </span>
          <pre className="overflow-auto rounded bg-neutral/5 p-2 text-xs">
            {JSON.stringify(attributes, null, 2)}
          </pre>
        </Col>
      )}
    </Col>
  );
};
